// Wording and formatting shared by the inbox list and the chat.

export const LEAD_STAGE_LABEL = {
  NEW: "New",
  ENGAGED: "Talking",
  SIGNUP_LINK_SENT: "Sign-up link sent",
  PLAN_INTERESTED: "Interested in a plan",
  DEMO_BOOKED: "Demo booked",
  CONVERTED: "Converted",
  LOST: "Lost",
};

const STATUS_LABEL = {
  sending: "Sending…",
  queued: "Sent",
  accepted: "Sent",
  sent: "Sent",
  delivered: "Delivered",
  read: "Read",
  failed: "Not delivered",
  undelivered: "Not delivered",
  discarded: "Not sent",
};

export const statusLabel = (status) => STATUS_LABEL[status] ?? null;
export const isFailedStatus = (status) => status === "failed" || status === "undelivered";

export function timeAgo(iso, now = Date.now()) {
  if (!iso) return "";
  const seconds = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return "now";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export const formatTime = (iso) =>
  iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

/**
 * RFC 4122 v4, for the reply's idempotency key. randomUUID needs a secure
 * context; the Math.random fallback is fine here because the key only has to
 * be unique per message, not unguessable.
 */
export function newClientMessageId() {
  const c = typeof window !== "undefined" ? window.crypto : undefined;
  if (c?.randomUUID) return c.randomUUID();
  const b = new Uint8Array(16);
  if (c?.getRandomValues) c.getRandomValues(b);
  else for (let i = 0; i < 16; i += 1) b[i] = Math.floor(Math.random() * 256);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
